import { render, staticRenderFns } from "./ProjectMainProjectSearch.vue?vue&type=template&id=7074f245"
import script from "./ProjectMainProjectSearch.vue?vue&type=script&lang=js"
export * from "./ProjectMainProjectSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports